import type { FaireProductEntity } from "../../entity_types/product";

export const p_3j3nmerutb: FaireProductEntity = {
  token: "p_3j3nmerutb",
  type: "product",
  name: "2.75'' Cute Large Flower Hair Claw Clips",
  brandToken: "b_2fgt3byexw",
  brandName: "TheDivaSoap",
  imageUrl:
    "https://cdn.faire.com/fastly/15285cc51f62d372598c9891f5ecec945c1ade801911c4fb85367c14d72642e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d5a2b43b7a80813c11e4515637eac31358a368a58cb32f0684cbdb22d453d920.jpeg",
    "https://cdn.faire.com/fastly/7da3eb3e85852addd157eefce650906e6705ec5d943c4b458977a41c24bdcbab.jpeg",
    "https://cdn.faire.com/fastly/36104252018b0780e8ecfbf00db3d2c0e887f666b240217eba0f067fec42e786.jpeg",
    "https://cdn.faire.com/fastly/10c5c57e553581e4d981efa3cd520343afb11dfc54584c8af2140dd19f1c651c.jpeg",
    "https://cdn.faire.com/fastly/3e2bb864810ca0fd9346d73e400fe0626ca422936109a2ec13c7b2e2d3fe6172.jpeg",
    "https://cdn.faire.com/fastly/4553ccf729676288dc6614df16d5cf9c155e94db051e607a3afbf6340edc2ddf.jpeg",
    "https://cdn.faire.com/fastly/8fe26612b9a9d0dabb07c7c24404bb0883f84719b4433661d9f656dd300249de.jpeg",
    "https://cdn.faire.com/fastly/8e9bbf2c53a8efa2302ff8991a97bdfbed2391372088613a4648f142783eba02.jpeg",
    "https://cdn.faire.com/fastly/f81e8bad821858bca6a73518a6968a1126867ca5b8f570bc2d114dc51f0d68f6.jpeg",
    "https://cdn.faire.com/fastly/52df033bafd867e9c9bd78b0d8febb5928cf5d7d6ff1571d2944b2692a217990.jpeg",
    "https://cdn.faire.com/fastly/e1ac1b1a4e9fbf977d62fe01a47322ab6d33267ce330e9d089516004c42f1328.jpeg",
    "https://cdn.faire.com/fastly/fc000a07ac4b675574c10f7c08688c9e6add4a91487cd838d1ce1d5ea3e4d1d2.jpeg",
    "https://cdn.faire.com/fastly/4a89edf8c13e5285a1f10de2ad0203053196b5a3dbaa448ab60e24f18aaac2e9.jpeg",
    "https://cdn.faire.com/fastly/f93089314ebd5edb30201df87fa64d60f112ec7f46949058cbd152a90ef27373.jpeg",
    "https://cdn.faire.com/fastly/db62589dd74196b18ec095f2822db9eb332b169a992defb8e9404609d06bc87a.jpeg",
    "https://cdn.faire.com/fastly/073458a796c579ba71c312458bfd0e7b08c304eb03f277831339449fdfd22d69.jpeg",
    "https://cdn.faire.com/fastly/ffc1ca554bd90680fc35303f58942ddd0c713ccc569a7701fd81321df4de9b92.jpeg",
    "https://cdn.faire.com/fastly/35f107249c46563942b9e8a6c0f61b87980dab50144d3da02f58423ad207dba1.jpeg",
    "https://cdn.faire.com/fastly/e72d792ed905e2cf6ffab25230774447c3ac140c384faf952ea87408e49b33a1.jpeg",
    "https://cdn.faire.com/fastly/8a1fe6375cce64ed0add32f636de23371b71d6aaae8b02351d7997e851ad3132.jpeg",
    "https://cdn.faire.com/fastly/ed681e00a2dbd4bcf1cf7e63b43bb4893e2ba3e33f2babd424e4d312ff133f05.jpeg",
  ],
  priceDollars: 1.49,
  description:
    "A simple hair jaw clamp is the perfect size to hold up your hair in a bun or other chic style. Also lovely for a half-bun updo. The multi-color clips could meet your all hairstyle and match different colors of clothes.\n\nMaterial: Resin\nDiameter: 2.87''\nThickness: 1.65''\nProcess: a matte finish is sprayed onto the resin clip\n\nPlease send us a picture of the clip if it breaks! A replacement will be sent or a refund will be processed!!! :)\n\n\nAdditionally, there may be colors that may differ from one computer to another by color resolutions.\n\nThe store supports item customization. If you are interested, please message me.\n\nAny concerns please message me,I will reply you as soon as possible :)\n\n❤️ Thank you for supporting small business ❤️\n\nTIPS:\n1. Avoid contact with chemicals.\n2. Recommend not to wear in the shower.\n3. Avoid violent impact.",
  tags: [],
  msrpDollars: 2.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:02.089Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
